import { Grid, Tooltip, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import React, { ReactNode } from 'react';

interface ICustomStyleProp {
  [key: string]: any;
}

interface IInputGridRowProps {
  preText?: string;
  text: string;
  subText?: string;
  children: ReactNode;
  style?: object;
  infoIconText?: string;
  subRowNumber?: number; // indents the grid and uses smaller typography
  endComponent?: ReactNode;
  endComponentStyle?: ICustomStyleProp;
}

const InputGridRow = ({
  preText,
  text,
  subText,
  children,
  style,
  subRowNumber,
  endComponent,
  endComponentStyle,
  infoIconText,
}: IInputGridRowProps) => {
  const hasEndComponent = !!endComponent;
  const typographyPaddingLeft = 0 + (8 + (subRowNumber || 0) * 16);
  const typographyFontSize = 16 - (subRowNumber || 0) * 2;
  return (
    <Grid
      container
      justify='flex-start'
      alignItems='center'
      direction='row'
      style={{
        marginTop: 7,
        marginBottom: 7,
        ...style,
      }}
    >
      {/* Render the input row text */}
      <Grid item xs={3}>
        <Typography
          style={{
            paddingLeft: typographyPaddingLeft,
            fontSize: typographyFontSize,
            fontWeight: 500,
          }}
        >
          <Typography
            style={{
              fontSize: 10,
              color: '#757575',
              marginRight: 5,
            }}
          >
            {preText}
          </Typography>
          {text}
          {infoIconText && infoIconText !== '' && (
            <Tooltip title={infoIconText}>
              <InfoIcon
                style={{
                  verticalAlign: 'bottom',
                  width: '1rem',
                  color: '#929599',
                  marginLeft: '5px',
                }}
              />
            </Tooltip>
          )}
          <Typography
            style={{
              fontSize: 10,
              color: '#757575',
              marginRight: 5,
            }}
          >
            {subText}
          </Typography>
        </Typography>
      </Grid>

      {/* Render the children, whether it's one or multiple */}
      {Array.isArray(children) ? (
        children.map((child: ReactNode) => (
          <Grid
            item
            style={{
              marginRight: 20,
            }}
          >
            {child}
          </Grid>
        ))
      ) : (
        <Grid item xs={hasEndComponent ? 6 : 8}>
          {children}
        </Grid>
      )}

      {/* End component, used for delete buttons, more options, etc. */}
      {/* Does not work if there are multiple children */}
      {hasEndComponent && !Array.isArray(children) && (
        <Grid
          item
          justify='flex-end'
          xs={3}
          alignContent='flex-end'
          alignItems='flex-end'
          style={{ ...endComponentStyle }}
          container
        >
          {endComponent}
        </Grid>
      )}
    </Grid>
  );
};

export default InputGridRow;
